module.exports = __webpack_public_path__ + "is.e24bc7a5801f3c9a9e8f.svg";


//////////////////
// WEBPACK FOOTER
// E:/proj/news12/zb-n12/scadmin/client/src/assets/fonts/flag-icon-css/flags/4x3/is.svg
// module id = ../../../../../src/assets/fonts/flag-icon-css/flags/4x3/is.svg
// module chunks = styles